/* eslint-disable react-hooks/exhaustive-deps */
import { FilterList } from '@mui/icons-material';
import { DatePicker } from '@mui/lab';
import {
  Badge,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete
} from '@mui/material';
import React, { useEffect, useState } from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function BillFilter({
  fetchSessionLogs,
  customerCompany,
  apCompany,
  createdDateFrom,
  createdDateTo,
  selectedCompanyType,
  selectedCustomerCompany,
  selectedApCompany,
  setSelectedCustomerCompany,
  setSelectedCompanyType,
  setSelectedApCompany,
  setCreatedDateFrom,
  setCreatedDateTo,
}) {
  const resetFilters = () => {
    setSelectedCustomerCompany('');
    setCreatedDateFrom('');
    setCreatedDateTo('');
    setSelectedCompanyType('');
    setSelectedApCompany('');
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    fetchSessionLogs();
    setOpen(false);
  };
  const [count, setCount] = useState(0);

  useEffect(() => {
    let totalCount = 0;

    if (selectedCustomerCompany) {
      totalCount++;
    }
    if (selectedCompanyType !== '') {
      totalCount++;
    }
    if (selectedApCompany) {
      totalCount++;
    }

    setCount(totalCount);
  }, [selectedCustomerCompany, selectedApCompany, selectedCompanyType]);

  return (
    <Paper>
      <Tooltip title='Filters'>
        <Badge badgeContent={count} color='error'>
          <IconButton onClick={handleOpen} aria-label='Filters' size='small'>
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open}>
        <Card sx={style} style={{ width: '500px' }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                <>
                  <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                      options={customerCompany}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options;
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={customerCompany.find((c) => c._id === selectedCustomerCompany) || null}
                      onChange={(e, newValue) => {
                        setSelectedCustomerCompany(newValue?._id || '');
                        setSelectedCompanyType(newValue ? 'customer_company' : '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Customer Company"
                          placeholder="Search customer companies..."
                          variant="outlined"
                        />
                      )}
                      fullWidth
                      sx={{
                        "& .MuiAutocomplete-listbox": {
                          maxHeight: 200,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                      options={apCompany}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options;
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={apCompany.find((c) => c._id === selectedApCompany) || null}
                      onChange={(e, newValue) => {
                        setSelectedApCompany(newValue?._id || '');
                        setSelectedCompanyType(newValue ? 'ap_company' : '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select AP Company"
                          placeholder="Search AP companies..."
                          variant="outlined"
                        />
                      )}
                      fullWidth
                      sx={{
                        "& .MuiAutocomplete-listbox": {
                          maxHeight: 200,
                        },
                      }}
                    />
                  </Grid>

                </>

                <Grid item xs={6} md={6} lg={6}>
                  <FormControl fullWidth>
                    <DatePicker
                      name='created_date_from'
                      format='YYYY-MM-DD'
                      renderInput={(props) => <TextField {...props} />}
                      label='Date From'
                      value={createdDateFrom || null}
                      onChange={(newValue) => {
                        let selectedDate = newValue;
                        var month = ('0' + parseInt(selectedDate?.getMonth() + 1)).slice(-2);
                        var day = ('0' + parseInt(selectedDate?.getDate())).slice(-2);
                        let date = selectedDate?.getFullYear() + '-' + month + '-' + day;
                        setCreatedDateFrom(date);
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={6} md={6} lg={6}>
                  <FormControl fullWidth>
                    <DatePicker
                      name='created_date_to'
                      format='YYYY-MM-DD'
                      renderInput={(props) => <TextField {...props} />}
                      label='Date To'
                      value={createdDateTo || null}
                      onChange={(newValue) => {
                        let selectedDate = newValue;
                        var month = ('0' + parseInt(selectedDate?.getMonth() + 1)).slice(-2);
                        var day = ('0' + parseInt(selectedDate?.getDate())).slice(-2);
                        let date = selectedDate?.getFullYear() + '-' + month + '-' + day;
                        setCreatedDateTo(date);
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <Typography variant='h6'>Searching Company Type</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedCompanyType === 'ap_company'}
                        onChange={(e) => {
                          if (selectedCompanyType === 'ap_company') {
                            setSelectedCompanyType('');
                          } else {
                            setSelectedCompanyType('ap_company');
                          }
                        }}
                      />
                    }
                    label='AP Company'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedCompanyType === 'customer_company'}
                        onChange={(e) => {
                          if (selectedCompanyType === 'customer_company') {
                            setSelectedCompanyType('');
                          } else {
                            setSelectedCompanyType('customer_company');
                          }
                        }}
                      />
                    }
                    label='Customer Company'
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color='error'>
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid container justifyContent={'flex-end'} item xs={12} md={6} lg={6}>
                  <Button onClick={handleClose} color='success'>
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default BillFilter;
